export default{
    changePhone:{
        titleState:{
            title1:'验证身份',
            title2:'修改手机号码',
            title3:'完成更换',
            title4:'已绑定的手机：',
            title5:'若该手机号已无法使用请联系客服',
        },
        showList:{
            show1:'验证码：',
            show2:'请输入短信验证码',
            show3:'下一步',
            show4:'手机号码：',
            show5:'请输入新的手机号码',
            show6:'手机号码更换成功',
            show7:'您可以在下次使用新号码进行登录',
            show8:'返回',
            show9:'获取验证码',
            show10:'请输入验证码',
            show11:'验证码已发送到您',
            show15:'手机上，请注意查收',
            show12:'s后重发',
            show13:'请输入手机号',
            show14:'请输入正确的手机号码',

        },
    }
    
}